<template>
  <v-container class="max-width">
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Goods Receipt</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn v-show="IsDistributor == 'Y'" color="red" text to="/check-missing-codes">
          <v-icon left dark green>mdi-file-excel</v-icon> Check Missing Codes
        </v-btn>

        <v-btn v-show="IsDistributor == 'Y'" color="blue" text to="/import-branch-stock">
          <v-icon left dark green>mdi-file-excel</v-icon> Import Branch Stock
        </v-btn>

      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-btn color="primary" class="mt-2" small to="/new-goods-receipt">
            <v-icon left dark>mdi-plus</v-icon>Create Goods Receipt
          </v-btn>

        </v-row>

        <v-row>
          <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
            hide-details></v-text-field>
        </v-row>

        <v-row>
          <v-col cols="12" xs="12" md="3" class="subtitle-2 text--primary">
            <span>Total Purchases:
              {{ TotalPurchases && TotalPurchases.toLocaleString() }}</span>
          </v-col>
          <v-col cols="12" sm="12" md="12" class="subtitle-2 text--primary">
            <!-- start of table -->
            <v-data-table :mobile-breakpoint="0" :headers="headers" :items="purchases" :search="search">
              <template v-slot:item.DocTotal="{ item }">
                <span>{{ item.DocTotal | currency }}</span>
              </template>

              <template v-slot:item.TotalPaid="{ item }">
                <span>{{ item.TotalPaid | currency }}</span>
              </template>

              <template v-slot:item.Balance="{ item }">
                <span>{{ item.Balance | currency }}</span>
              </template>

              <template v-slot:item.Date="{ item }">
                <span>{{ item.Date | date }}</span>
              </template>

              <template v-slot:item.action="{ item }">
                <v-btn text color="accent" :to="`/goods-receipt/${item.id}`">
                  <v-icon left>mdi-eye</v-icon> More Details
                </v-btn>
              </template>
            </v-data-table>
            <!-- end -->
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  computed: {
    IsDistributor() {
      return localStorage.getItem("IsDistributor");
    },
  },
  data: () => ({
    search: "",
    TotalPurchases: null,
    TotalPayments: null,
    TotalBalance: null,
    headers: [
      { text: "Doc No.", value: "DocNum" },
      { text: "Supplier", value: "SupplierName" },
      { text: "Vehicle", value: "vehicleNo" },
      { text: "Driver", value: "driverName" },
      { text: "Total Amount", value: "DocTotal" },
      { text: "Total Paid", value: "TotalPaid" },
      { text: "Balance", value: "Balance" },
      { text: "Date", value: "Date" },
      { text: "View Details", value: "action" },
    ],
    purchases: [],
  }),
  methods: {
    getRecords() {
      let data = {};
      data.StartDate = new Date().toISOString().substr(0, 10);
      data.CustomerId = null;
      const url = "/daily-purchases-report";
      const self = this;
      this.$store.commit("loader", true);
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.purchases = res.ResponseData.purchases;
            self.TotalPurchases = res.ResponseData.TotalPurchases;
            self.$store.commit("loader", false);
          } else {
            self.$store.commit("loader", false);
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          self.$store.commit("loader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    this.getRecords();
  },
};
</script>